import api from "./axios";
import type { AuthUser, ApiMessage } from "@/types";
import { ApiPath } from "@/constants/apiPaths";

export const getGoogleAuthUrl = () =>
  `${process.env.API_URL || ""}/api/auth/google`;

export const logout = () =>
  api.post<ApiMessage>(ApiPath.AuthLogout).then((r) => r.data);

export const getMe = () =>
  api.get<AuthUser>(ApiPath.UsersMe).then((r) => r.data);

export const deleteMyAccount = () =>
  api.delete<ApiMessage>(ApiPath.UsersMe).then((r) => r.data);
